import { render, staticRenderFns } from "./MoveNoticesDetails.vue?vue&type=template&id=d0995ddc&scoped=true&"
import script from "./MoveNoticesDetails.vue?vue&type=script&lang=js&"
export * from "./MoveNoticesDetails.vue?vue&type=script&lang=js&"
import style0 from "./MoveNoticesDetails.vue?vue&type=style&index=0&id=d0995ddc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0995ddc",
  null
  
)

export default component.exports